var FONT_FAMILY_MONTSERRAT = 'Montserrat';
var FONT_FAMILY_OPEN_SANS = 'Open Sans';
var FONT_FAMILY_SOURCE_CODE_PRO = 'Source Code Pro';
export var fontFamilies = {
  body: "var(--cds-font-open-sans, ".concat(FONT_FAMILY_OPEN_SANS, ")"),
  display: "var(--cds-font-montserrat, ".concat(FONT_FAMILY_MONTSERRAT, ")"),
  headline: "var(--cds-font-montserrat, ".concat(FONT_FAMILY_MONTSERRAT, ")"),
  label: "var(--cds-font-open-sans, ".concat(FONT_FAMILY_OPEN_SANS, ")"),
  title: "var(--cds-font-open-sans, ".concat(FONT_FAMILY_OPEN_SANS, ")"),
  code: "var(--cds-font-source-code-pro, ".concat(FONT_FAMILY_SOURCE_CODE_PRO, ")")
};